<template>
  <v-row class="flex-column mt-6 pr-8">
    <v-col class="custom-panel">
      <v-row class="flex-column">
        <v-col class="custom-panel__header">
          Edit License
          <v-btn icon @click="$router.push('/licences')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
        <v-form v-model="valid" class="form-right-view-lable">
          <v-col class="custom-form mt-5">
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Company *</label></v-col
              >
              <v-col sm="8">
                <v-text-field v-model="company" :rules="companyRules" filled autofocus/>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Company Email *</label></v-col
              >
              <v-col sm="8">
                <v-text-field
                  v-model="companyEmail"
                  :rules="emailRules"
                  filled
                  disabled
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Tier Type *</label></v-col
              >
              <v-col sm="4">
                <v-select
                  v-model="selectedTierType"
                  :item-text="(item) => item.tierName"
                  :items="tierList"
                  :item-value="(item) => item.id"
                  filled
                  append-icon="expand_more"
                  label="Select"
                  disabled
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label"
                  >Products Included</label
                ></v-col
              >
              <v-col sm="9">
                <v-tabs
                  v-model="model"
                  class="custom-tabs"
                  slider-color="white"
                >
                  <v-tab
                    v-for="(product, i) in productList"
                    :key="i"
                    :href="'#tab-' + product.name"
                    >{{ product.name }}</v-tab
                  >

                  <v-tabs-items v-model="model" class="custom-tabs__cont">
                    <v-tab-item
                      v-for="(product, i) in productList"
                      :key="i"
                      :value="'tab-' + product.name"
                    >
                      <v-row
                        v-for="(row, index) in emailRows.filter(
                          (el) => el.productId === product.id && el.isActive,
                        )"
                        :key="index"
                        no-gutters
                        class="emp_row"
                      >
                        <v-col sm="3"
                          ><label class="custom-form__label"
                            >Employee Email *</label
                          ></v-col
                        >
                        <v-col sm="5" class="pr-8"
                          ><v-text-field
                            v-model="row.email"
                            :rules="emailRules"
                            filled
                            @input="userEmailCheck(product)"
                            :disabled="disableEmailField(row)"
                          />
                          <p
                            v-if="
                              isDuplicate &&
                                index ===
                                  emailRows.filter((el) => el.productId === product.id && el.isActive).length -
                                    1
                            "
                            style="color: red"
                          >
                            Duplicated email
                          </p>
                        </v-col>
                        <v-col class="no-wrap mt-2" sm="3"
                          ><v-checkbox
                            @change="adminCheck"
                            v-model="row.check"
                            label="Super Admin"
                        /></v-col>
                        <v-col sm="1" class="no-wrap mt-2">
                          <v-btn
                            :disabled="
                              isDuplicate ||
                                emailRows.filter(
                                  (el) =>
                                    el.productId === product.id && el.isActive,
                                ).length >= product.users
                            "
                            icon
                            @click="addRow(product)"
                          >
                            <v-icon
                              color="#7F7F7F"
                              size="18"
                              class="font-weight-bold"
                              >add</v-icon
                            >
                          </v-btn>
                          <v-btn
                            :disabled="
                                emailRows.filter(
                                  (el) =>
                                    el.productId === product.id && 
                                    el.isActive,
                                ).length == 1
                            "
                            icon
                            @click="deleteRow(index, product, row)"
                          >
                            <v-icon
                              color="#7F7F7F"
                              size="16"
                              class="font-weight-bold"
                              >close</v-icon
                            >
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs-items>
                </v-tabs>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center mt-8">
                <font color="red">{{ text }}</font>
              </v-col>
              <v-col class="text-center mt-8">
                <v-btn
                  :disabled="!valid || buttonCheck() || superAdminCheck"
                  class="primary_btn small"
                  depressed
                  @click="updateLicenseByid"
                  >Save
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-form>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { storeActions } from '@/store/actions.constants';
export default {
  data: () => ({
    valid: false,
    company: null,
    companyEmail: null,
    tierTypes: [],
    model: 'tab-2',
    isDuplicate: false,
    emailRows: [],
    superAdminCheck: false,
    selectedTierType: null,
    tierData: [],
    text: null,
    emailRules: [
      (v) => !!v || 'Email required',
      (v) => /@.+\..+/.test(v) || 'Invalid email',
    ],
    companyRules: [
      (v) => !!v || 'Company required',
      (v) =>
        /^[a-zA-Z][a-zA-Z0-9\s ]{2,19}$/.test(v) ||
        'Special characters and Initial numbers are not allowed and string length must be between 3 to 20.',
    ],
  }),
  computed: {
    tierList() {
      return this.tierTypes.map((tier) => ({
        id: tier.id,
        tierName: tier.tier_name,
      }));
    },
    productList() {
      let products = [];
      this.tierData.map((el) => {
        if (el.product_id === 1)
          products.push({
            id: el.product_id,
            name: 'TED',
            users: el.no_of_users,
          });
        if (el.product_id === 2)
          products.push({
            id: el.product_id,
            name: 'Mobe',
            users: el.no_of_users,
          });
        if (el.product_id === 3)
          products.push({
            id: el.product_id,
            name: 'PACE',
            users: el.no_of_users,
          });
      });
      // console.log(products)
      return products;
    },
    ...mapGetters({
      //  getLicense: 'licensees/getLicense',
    }),
  },
  async mounted() {
    // console.log(this.$route.params.id)
    let id = this.$route.params.id;
    let res = await this.getTierDetails();
    this.tierTypes = res.data;
    await this.getLicensesByid(id);
  },
  methods: {
    ...mapActions({
      getTierById: 'licensees/getTierById',
      getLicense: 'licensees/getLicense',
      getTierDetails: 'licensees/getTierDetails',
      getLicenseByid: 'licensees/getLicenseByid',
      updateLicense: 'licensees/updateLicenseByid',
      getTierList: 'licensees/getTierList',
    }),
    disableEmailField(row){
      if(row.NotDisabled) return false
      else if (row.email && row.email !== '')return true;
      else{
        row.NotDisabled =true;
        return false;
      }
    },
    getLicensesByid(id) {
      let licenseObj = {
        licenseId: id,
      };
      // this.$store.dispatch(`users/${storeActions.loginAction}`, usrObj).then((res) => console.log(res))
      this.getLicenseByid(licenseObj)
        .then((res) => {
          //   this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          //   text: res.data.message,
          //   timeout: 1000,
          //   color: "success",
          // });
          //  console.log(res)
          this.company = res.data.organization_name;
          this.companyEmail = res.data.primary_email_id;
          this.selectedTierType = res.data.tier_id;
          this.editId = res.data.customer_id;
          this.emailRows = res.data.employeeEmails;
          this.emailRows = this.emailRows.map((el) => {
            el['check'] = el.roleId !== 6 ? false : true;
            el['isActive'] = true;
            el['isNew'] = false;
            return el;
          });
          this.tierByID();

          // this.emailRows=this.emailRows.map(el)
          // console.log(res)
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          // Skip login until API and schema got finalise
          this.text = err.message;
          console.error(err);
        });
    },

    getTierList() {
      this.getTierDetails({
        tier_id: this.selectedTierType,
      });
    },
    tierByID() {
      const tierPayload = {
        tier_id: this.selectedTierType,
      };
      this.getTierById(tierPayload)
        .then((res) => {
          this.tierData = res.data.products;
          this.productList.forEach((element) => {
            if (
              this.emailRows.filter((el) => el.productId === element.id)
                .length == 0
            ) {
              this.emailRows.push({
                email: null,
                check: false,
                productId: element.id,
                isActive: true,
              });
            }
          });
        })
        .catch((err) => {
          //
          // Skip login until API and schema got finalise
          this.text = err.message;
          console.error(err);
        });
    },
    buttonCheck() {
      if (
        this.company == null ||
        this.company === '' ||
        this.companyEmail == null ||
        this.selectedTierType == null ||
        this.isDuplicate
      ) {
        return true;
      } else {
        return false;
      }
    },
    adminCheck() {
      var check = (val) => val.check === false;
      if (this.emailRows.filter((el) => el.isActive).every(check)) {
        this.superAdminCheck = true;
      } else {
        this.superAdminCheck = false;
      }
    },
    userEmailCheck(product) {
      let row = this.emailRows.filter((el) => el.productId == product.id);

      if (row && row.length > 1) {
        let index = row.length - 1;
        let _email = row[index].email;
        this.isDuplicate = false;
        row.forEach((item, index) => {
          
         if (item.email && _email && item.isActive && 
              item.email.toLowerCase()==_email.toLowerCase() 
              && index != row.length - 1 )
          {
            this.isDuplicate = true;
          }
        })
        // let count = this.emailRows.filter(
        //   (item, index) =>
        //     item.email == _email && index != this.emailRows.length - 1,
        // ).length;
        // if (count > 0) {
        //   this.isDuplicate = true;
        // } else {
        //   this.isDuplicate = false;
        // }
      }
    },
    // userEmailCheck() {
    //   if (this.emailRows.length > 1) {
    //     let index = this.emailRows.length - 1;
    //     let _email = this.emailRows[index].email;
    //     this.isDuplicate = false;
    //     this.emailRows.forEach((item, index) => {
    //       if (
    //         item.email.toLowerCase() == _email.toLowerCase() &&
    //         index != this.emailRows.length - 1 &&
    //         item['isActive']
    //       ) {
    //         this.isDuplicate = true;
    //       }
    //     });
    //     // let count = this.emailRows.filter(
    //     //   (item, index) =>
    //     //     item.email == _email && index != this.emailRows.length - 1,
    //     // ).length;
    //     // if (count > 0) {
    //     //   this.isDuplicate = true;
    //     // } else {
    //     //   this.isDuplicate = false;
    //     // }
    //   }
    // },
    addRow: function(product) {
      // console.log(this.emailRows);
      this.emailRows.push({
        email: '',
        check: false,
        productId: product.id,
        isActive: true,
        isNew: true,
        roleId: 7,
        NotDisabled:true
      });
    },

    deleteRow(index, product, user) {
      if (user.isNew) {
        let ind = this.emailRows.findIndex(
          (el) => el.productId === product.id && el.email === user.email,
        );
        this.emailRows.splice(ind, 1);
      } else {
        this.emailRows = this.emailRows.map((row) => {
          console.log(row.email, user.email);
          if (row.email === user.email && row.productId === product.id) {
            row['isActive'] = false;
          }
          return row;
        });
      }
      console.log(this.emailRows);
      if (
        this.emailRows.filter((el) => el.check && el['isActive']).length < 1
      ) {
        console.log(this.superAdminCheck);
        this.superAdminCheck = true;

        console.log(this.emailRows);
      } else {
        this.superAdminCheck = false;
      }
      this.userEmailCheck(product);
      console.log(this.superAdminCheck);
    },
    updateLicenseByid() {
      this.emailRows = this.emailRows.filter((item) => item.email);
      let rowsToAdd = this.emailRows.map((el) => ({
        email: el.email,
        check: el.check,
        roleId: el.check === true ? 6 : 7,
        productId: el.productId,
        isActive: el.isActive,
      }));
      const licenseObj = {
        organization_name: this.company,
        primary_email_id: this.companyEmail,
        tier_id: this.selectedTierType,
        employeeEmails: rowsToAdd,
        customer_id: this.editId,
      };
      // this.$store.dispatch(`users/${storeActions.loginAction}`, usrObj).then((res) => console.log(res))
      this.updateLicense(licenseObj)
        .then((res) => {
          // console.log(res);
          if (res.status === 200) {
            this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
              text: res.data.message,
              timeout: 1000,
              color: 'success',
            });
            // this.getLicense();
            this.$router.push('/licences');
          } else {
            this.text = res.data.message;
          }
        })
        .catch((err) => {
          // Skip login until API and schema got finalise
          // this.$router.push('/licences');
          this.text = err;
          console.error(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.no-wrap {
  white-space: nowrap;
}
</style>
